import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const PURCHASEORDERTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PurchaseOrderType.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.PurchaseOrderType.SapCode')
    .required()
    .minLength(2)
    .maxLength(20)
    .build(),
];

export const PURCHASEORDERTYPE_CONFIG = {
  entityName: 'PurchaseOrderType',
  localizationKey: 'Controlling::Entity.PurchaseOrderType',
  fields: PURCHASEORDERTYPE_FIELDS,
  permission: 'ControllingSap.PurchaseOrderTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
